import classNames from "classnames";
import {
  TypingIndicatorProps,
  useChannelStateContext,
  useChatContext,
  useTypingContext,
} from "stream-chat-react";

export const TypingIndicator = (props: TypingIndicatorProps) => {
  const { threadList } = props;
  const { channelConfig, thread } = useChannelStateContext();
  const { client } = useChatContext();
  const { typing = {} } = useTypingContext();

  if (channelConfig?.typing_events === false) {
    return null;
  }

  const typingUsers = Object.values(typing).filter(({ parent_id, user }) => {
    const isCurrentUser = user?.id === client.user?.id;
    const isInThread = threadList ? parent_id === thread?.id : !parent_id;
    return !isCurrentUser && isInThread;
  });

  if (typingUsers.length === 0) {
    return null;
  }

  const typingUserNames = typingUsers.map(({ user }) => user?.name).join(", ");
  const isMultipleUserTyping = typingUsers.length > 1;

  return (
    <div
      className={classNames(
        "str-chat__typing-indicator t-ml-[min(16px,4%)] !t-bg-surface-transparent t-absolute t-left-0 t-z-10",
        {
          "str-chat__typing-indicator--typing": typingUsers.length > 0,
        }
      )}
    >
      <div className="str-chat__typing-indicator__avatars">
        <div className="t-flex t-items-center t-gap-2">
          <div className="t-text-body-sm t-text-text-30">
            {typingUserNames} {isMultipleUserTyping ? "are" : "is"} typing{" "}
          </div>
          <div className="str-chat__typing-indicator__dots t-mt-[3px]">
            <div className="str-chat__typing-indicator__dot t-size-[3px]" />
            <div className="str-chat__typing-indicator__dot t-size-[3px]" />
            <div className="str-chat__typing-indicator__dot t-size-[3px]" />
          </div>
        </div>
      </div>
    </div>
  );
};
